import React from 'react';
import PropTypes from 'prop-types';
import './button.scss';

/**
 * Atomic Button component
 * @param {Object} props
 * @param {string} props.variant - Button variant (e.g., 'xl')
 * @param {boolean} props.loading - Loading state
 * @param {React.ReactNode} props.children - Button label/content
 * @param {string} props.className - Additional class names
 */
const AppButton = ({ variant = '', loading = false, children, className = '', disabled, ...rest }) => {
   const variantClass = variant ? `ct-${variant}` : '';

   return (
      <button className={`ct-button ct-flex ct-aiCenter ct-jcCenter ${variantClass} ${className}`} disabled={disabled || loading} {...rest}>
         {children}
      </button>
   );
};

AppButton.propTypes = {
   variant: PropTypes.string,
   loading: PropTypes.bool,
   children: PropTypes.node,
   className: PropTypes.string,
   disabled: PropTypes.bool,
};

export default AppButton;
